import { useTranslation } from 'react-i18next';
import { AccountIcon } from '../../icons';
import { NotYetListItem } from './NotYetListItem';

export function NoAccountsListItem() {
  const { t } = useTranslation();
  return <NotYetListItem icon={<AccountIcon />} title={t('No accounts yet')} />;
}
